<div class="snackbar">
    <div class="snackbar__info">
        <mb-icon
            *ngIf="icon"
            class="icon"
            [svgColor]="iconColor"
            [icon]="icon"
            size="sm"
        ></mb-icon>
        <span>{{ message }}</span>
    </div>
    <mb-icon
        class="close-snackbar"
        icon="close"
        [svgColor]="iconColor"
        (click)="close()"
        size="sm"
    ></mb-icon>
</div>
